import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy,Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatAutocomplete, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatButton } from '@angular/material/button';
import { MatCard, MatCardActions, MatCardContent, MatCardTitle } from '@angular/material/card';
import { MatOption } from '@angular/material/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { Router } from '@angular/router';

import { ViewContextService, ViewContextStore } from 'app/navigation/view-context.service';
import { ShortStoreEnvPipe } from 'app/shared/utilities/short-store-env.pipe';

import { SelectableStoreElementComponent } from './selectable-store-element.component';

@Component({
    templateUrl: './store-selector-page.component.html',
    styleUrls: ['./store-selector-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatCard, MatCardTitle, MatCardContent, MatFormField, MatLabel, MatInput, FormsModule, MatAutocompleteTrigger, MatAutocomplete, MatOption, NgClass, MatCardActions, MatButton, SelectableStoreElementComponent, ShortStoreEnvPipe]
})
export class StoreSelectorPageComponent implements OnInit {
    private readonly router = inject(Router);
    private readonly viewContextService = inject(ViewContextService);

    availableContexts: ViewContextStore[];
    filteredContexts: ViewContextStore[];
    contextFilterText: string = '';
    selectedStore?: ViewContextStore;

    ngOnInit(): void {
        this.viewContextService.availableContexts$.subscribe(contexts => {
            this.availableContexts = [...contexts.filter(x => x.type === 'store')] as ViewContextStore[];
            this.updateFilter();
        });
    }

    updateFilter() {
        let filterText = this.contextFilterText.toLowerCase();
        this.filteredContexts = this.availableContexts.filter(c => {
            if (!filterText) {
                return true;
            }
            return c.storeId.toLowerCase().includes(filterText) || c.storeLabel.toLowerCase().includes(filterText);
        });
    }

    selectStore(store: ViewContextStore | undefined) {
        if (!store) {
            return;
        }
        const redirectSubPath = localStorage.getItem('routeRedirectAfterStoreSelect') || 'dashboards/overview';
        localStorage.removeItem('routeRedirectAfterStoreSelect');
        this.router.navigateByUrl(`stores/${encodeURIComponent(store.storeId)}/${redirectSubPath}`);
    }

    updateSelectedStore(storeId: string) {
        this.selectedStore = this.availableContexts.find(x => x.storeId == storeId);
    }
}
